import template from './preliminaryAssessment.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    validationErrors: '<',
    contacts: '<',
    assetDetails: '<',
    compareProducts: '<',
    compliance: '<',
    objectives: '<',
    lenders: '<',
    documents: '<',
    additionalProduct: '<',
    financeProposal: '<',
    showNetMonthlySurplus: '<',
    showFinancialPosition: '<',
    showBidFlows: '<',
    assetCommitmentSchedules: '<',
    assets: '<',
    liabilities: '<',
    income: '<',
    expenses: '<',
    showExpenses: '<',
    workflow: '<',
    idTicket: '<',
    isCommercial: '<',
    isDealOwnerBroker: '<',
    onChanged: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $timeout,
      helperService,
      assetFinanceService,
      assetsService,
      liabilitiesService,
      incomeService,
      householdsService,
      financesService,
      AssetFinanceCompliance
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentTimeZone = null;
      ctrl.currentLocale = null;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.organizationCountry = null;
      ctrl.existingInvestmentProperties = [];
      ctrl.existingOwnerOccupiedProperties = [];
      ctrl.newInvestmentProperties = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.contacts = ctrl.contacts || [];
        ctrl.assetDetails = ctrl.assetDetails || [];
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.preferredProduct = assetFinanceService.getPreferredProduct(ctrl.compareProducts);
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.compliance = ctrl.compliance || {};
        ctrl.objectives = ctrl.objectives || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.preferredLender = _.find(
          ctrl.lenders,
          (l) => l?.id === ctrl.preferredProduct?.selectedProduct?.lender[0]?.id
        );
        ctrl.documents = ctrl.documents || [];
        ctrl.additionalProduct = ctrl.additionalProduct || {};
        ctrl.financeProposal = ctrl.financeProposal || {};
        ctrl.showNetMonthlySurplus = ctrl.showNetMonthlySurplus || false;
        ctrl.showFinancialPosition = ctrl.showFinancialPosition || false;
        ctrl.showBidFlows = ctrl.showBidFlows || false;
        ctrl.assetCommitmentSchedules = ctrl.assetCommitmentSchedules || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.income = ctrl.income || [];
        ctrl.expenses = ctrl.expenses || [];
        ctrl.filteredExpenses = _.filter(ctrl.expenses, (e) => _.isUuid(e?.id));
        ctrl.showExpenses = ctrl.showExpenses || false;
        ctrl.workflow = ctrl.workflow || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.totalAssetCost = _.reduce(
          ctrl.assetDetails || [],
          (sum, n) => _.add(sum, _.toNumber(n?.cost || 0)),
          0
        );
        ctrl.totalAssetNetCost = _.reduce(
          ctrl.assetDetails || [],
          (sum, n) => _.add(sum, _.toNumber(n?.netCost || 0)),
          0
        );
        ctrl.existingInvestmentProperties = helperService.getInvestmentAssets({
          assets: ctrl.assets
        });
        if (ctrl.organizationCountry.cca2 === 'NZ') {
          ctrl.existingOwnerOccupiedProperties = helperService.getOwnerOccupiedAssets({
            assets: ctrl.assets
          });
        }
        ctrl.charts = {
          netAssetPosition: {
            values: [],
            height: '100%',
            width: '100%',
            legends: [],
            colors: ['#03A9F4'],
            symbol: ctrl.currentCurrency?.symbol,
            isOut: true
          },
          monthlyFinancialPosition: {
            values: [],
            height: '100%',
            width: '100%',
            legends: [],
            colors: ['#03A9F4'],
            symbol: ctrl.currentCurrency?.symbol,
            isOut: true
          },
          financialRiskIndicator: {
            minValue: 0,
            maxValue: 100,
            value: 0,
            height: '100%',
            width: '100%',
            colors: ['#4CAF50', '#FF9800', '#F44336'],
            legends: [{ name: '-' }],
            ranges: [0.25, 0.6]
          },
          financialStressIndicator: {
            minValue: 0,
            maxValue: 100,
            value: 0,
            height: '100%',
            width: '100%',
            colors: ['#4CAF50', '#FF9800', '#F44336'],
            legends: [{ name: '-' }],
            ranges: [0.15, 0.35, 0.6]
          },
          hemVariance: {
            minValue: 0,
            maxValue: 100,
            value: 0,
            height: '100%',
            width: '100%',
            colors: ['#4CAF50', '#F44336', '#F44336'],
            legends: [{ name: '-' }],
            ranges: [0, 0.01]
          },
          debtToIncomeRatio: {
            minValue: 0,
            maxValue: 15,
            value: 0,
            height: '100%',
            width: '100%',
            colors: ['#4CAF50', '#FF9800', '#F44336'],
            legends: [{ name: '-' }],
            ranges: [0.2, 0.47]
          },
          isNetAssetPositionReady: false,
          isMonthlyFinancialPositionReady: false,
          isFinancialRiskIndicatorReady: false,
          isFinancialStressIndicatorReady: false,
          isHemVarianceReady: false,
          isDebtToIncomeRatioReady: false
        };
        if (!ctrl.isCommercial && ctrl.showBidFlows && ctrl.organizationCountry.cca2 !== 'NZ') {
          ctrl.isProcessing = true;
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.financeMonthlyFinancialPositionEstimate = () => {
        financesService
          .monthlyFinancialPosition({ idTicket: ctrl.idTicket || '' })
          .then((res) => {
            if (res?.status && !_.isEmpty(res?.compliance)) {
              ctrl.compliance = AssetFinanceCompliance.Build(res?.compliance);
              const data = {
                compliance: ctrl.compliance
              };
              ctrl.onChanged({ data });
            }
            ctrl.isProcessing = false;
            ctrl.summaryCharts();
          });
      };

      ctrl.summaryCharts = () => {
        // Net asset position
        const totalAssets = ctrl.compliance?.monthlyFinancialPosition?.totalAssets || 0;
        const totalLiabilities =
          ctrl.compliance?.monthlyFinancialPosition?.totalLiabilities || 0;
        const netAssetPosition =
          ctrl.compliance?.monthlyFinancialPosition?.netAssetPosition || 0;
        ctrl.charts.netAssetPosition.values.push(
          {
            name: 'Net asset position',
            value: [netAssetPosition],
            color: ['#4CAF50', '#F44336']
          },
          {
            name: 'Total liabilities',
            value: [totalLiabilities]
          },
          {
            name: 'Total assets',
            value: [totalAssets]
          }
        );
        $timeout(() => {
          ctrl.charts.isNetAssetPositionReady = true;
        });

        // Monthly financial position
        const netMonthlyIncome =
          ctrl.compliance?.monthlyFinancialPosition?.netIncome?.proposedPosition || 0;
        const totalOutgoings = ctrl.compliance?.monthlyFinancialPosition?.totalOutgoings || 0;
        const netCashPosition = ctrl.compliance?.monthlyFinancialPosition?.netCashPosition || 0;
        ctrl.charts.monthlyFinancialPosition.values.push(
          {
            name: 'Net cash position',
            value: [netCashPosition],
            color: ['#4CAF50', '#F44336']
          },
          {
            name: 'Total outgoings',
            value: [totalOutgoings]
          },
          {
            name: 'Net monthly income',
            value: [netMonthlyIncome]
          }
        );
        $timeout(() => {
          ctrl.charts.isMonthlyFinancialPositionReady = true;
        });

        // Financial risk indicator
        ctrl.charts.financialRiskIndicator.value =
          ctrl.compliance?.monthlyFinancialPosition?.financialRisk || 0;
        if (ctrl.compliance?.monthlyFinancialPosition?.financialRisk <= 25) {
          ctrl.charts.financialRiskIndicator.legends[0] = { name: 'Low' };
        }
        if (
          ctrl.compliance?.monthlyFinancialPosition?.financialRisk > 25 &&
          ctrl.compliance?.monthlyFinancialPosition?.financialRisk <= 60
        ) {
          ctrl.charts.financialRiskIndicator.legends[0] = { name: 'Medium' };
        }
        if (
          ctrl.compliance?.monthlyFinancialPosition?.financialRisk > 60 &&
          ctrl.compliance?.monthlyFinancialPosition?.financialRisk <= 100
        ) {
          ctrl.charts.financialRiskIndicator.legends[0] = { name: 'High' };
        }
        $timeout(() => {
          ctrl.charts.isFinancialRiskIndicatorReady = true;
        });

        // Financial stress indicator
        if (
          ctrl.compliance?.monthlyFinancialPosition?.surplusDeficit
            ?.proposedPositionAtBufferRate <= 0
        ) {
          ctrl.charts.financialStressIndicator.value = 60;
          ctrl.charts.financialStressIndicator.legends[0] = { name: 'High' };
        }
        if (
          ctrl.compliance?.monthlyFinancialPosition?.surplusDeficit
            ?.proposedPositionAtBufferRate > 0 &&
          ctrl.compliance?.monthlyFinancialPosition?.surplusDeficit
            ?.proposedPositionAtBufferRate < 1000
        ) {
          ctrl.charts.financialStressIndicator.value = 35;
          ctrl.charts.financialStressIndicator.legends[0] = { name: 'Medium' };
        }
        if (
          ctrl.compliance?.monthlyFinancialPosition?.surplusDeficit
            ?.proposedPositionAtBufferRate >= 1000
        ) {
          ctrl.charts.financialStressIndicator.value = 15;
          ctrl.charts.financialStressIndicator.legends[0] = { name: 'Low' };
        }
        $timeout(() => {
          ctrl.charts.isFinancialStressIndicatorReady = true;
        });

        // HEM variance
        const hemVariance = ctrl.compliance?.monthlyFinancialPosition?.hemVariance || 0;
        ctrl.charts.hemVariance.value = hemVariance
          ? _.multiply(_.divide(hemVariance, -3000), 100)
          : 0;
        if (ctrl.charts.hemVariance.value > 100) {
          ctrl.charts.hemVariance.value = 100;
        }
        if (ctrl.charts.hemVariance.value <= 0) {
          ctrl.charts.hemVariance.value = 0;
        }
        ctrl.charts.hemVariance.legends[0] = {
          name: `${hemVariance.formatWithCurrency($rootScope.CurrentCurrency())}`
        };
        $timeout(() => {
          ctrl.charts.isHemVarianceReady = true;
        });

        // Debt to income ration (DTI)
        ctrl.charts.debtToIncomeRatio.value =
          ctrl.compliance?.monthlyFinancialPosition?.debtToIncomeRatio || 0;
        ctrl.charts.debtToIncomeRatio.legends[0] = {
          name: `${ctrl.charts.debtToIncomeRatio.value}`
        };
        $timeout(() => {
          ctrl.charts.isDebtToIncomeRatioReady = true;
        });
      };

      ctrl.getAssetValuePerOwnershipPercentage = (value, percent) =>
        assetsService.getAssetValuePerOwnershipPercentage(value, percent);

      ctrl.totalAssets = () =>
        assetsService.getTotalAssets(ctrl.assets, ctrl.assetCommitmentSchedules);

      ctrl.getLiabilityBalancePerOwnershipPercentage = (value, percent) =>
        liabilitiesService.getLiabilityBalancePerOwnershipPercentage(value, percent);

      ctrl.totalAllLiabilitiesBalance = () =>
        liabilitiesService.getTotalLiabilitiesBalance(
          ctrl.liabilities,
          ctrl.assetCommitmentSchedules
        );

      ctrl.totalExistingRepayments = () =>
        _.multiply(
          helperService.getTotalExistingLiabilitiesRepayments({
            liabilities: ctrl.liabilities,
            assetCommitmentSchedules: ctrl.assetCommitmentSchedules,
            contacts: ctrl.contacts,
            workflow: ctrl.workflow,
            isCurrent: true
          }),
          12
        );

      ctrl.getAssetCommitmentScheduleTotal = (field) =>
        helperService.getAssetCommitmentScheduleTotal({
          assetCommitmentSchedules: ctrl.assetCommitmentSchedules,
          field
        });

      ctrl.totalAllIncomePerContact = (idContact) =>
        incomeService.getTotalAllIncomeByContact({
          income: ctrl.income,
          idContact,
          contacts: ctrl.contacts,
          assets: ctrl.assets,
          homeLoanSecurities: ctrl.homeLoanSecurities,
          workflowType: ctrl.workflow.type,
          isDealOwnerBroker: ctrl.isDealOwnerBroker,
          haveLendersExisting: ctrl.lenders.length > 0,
          isUsingForFinanceCalculations: false
        });

      ctrl.totalAllIncome = () => {
        let total = 0;
        for (let i = 0; i < ctrl.contacts.length; i += 1) {
          total += ctrl.totalAllIncomePerContact(ctrl.contacts[i].id);
        }
        return total;
      };

      ctrl.totalExpensesByHousehold = ({ householdExpenses }) =>
        _.multiply(
          householdsService.getTotalOrGroupTotalExpensesByHousehold({ householdExpenses }),
          12
        );

      ctrl.totalExpenses = () =>
        _.multiply(
          householdsService.getTotalExpenses({
            expenses: ctrl.expenses,
            contacts: ctrl.contacts
          }),
          12
        );

      ctrl.totalProposedRepayment = () =>
        _.multiply(ctrl.financeProposal.estimatedRepayment, 12);

      ctrl.getMonthlyFinancialSurplusDeficit = () =>
        ctrl.totalAllIncome() -
        ctrl.totalExpenses() -
        ctrl.totalExistingRepayments() -
        ctrl.totalProposedRepayment();

      ctrl.getContactNames = ({ household }) =>
        household?.idContacts?.length
          ? `${_.map(
              _.filter(ctrl.contacts, (c) => household?.idContacts.indexOf(c?.id) > -1),
              (h) => h?.getName()
            ).join(', ')}`
          : '-';

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.getLender = () => {
        let lender;
        if (ctrl.lenders.length) {
          lender = ctrl.lenders.find(
            (l) => l.id === ctrl.preferredProduct.selectedProduct.lender[0].id
          );
        }
        return lender;
      };

      ctrl.getLenderDocument = () => {
        const type = 'LOGO';
        let doc;
        if (ctrl.documents.length) {
          doc = ctrl.documents.find((d) =>
            d.lender[0]
              ? d.lender[0].id === ctrl.preferredProduct.selectedProduct.lender[0].id &&
                d.type.indexOf(type) > -1
              : undefined
          );
        }
        return doc ? doc.url : '';
      };

      ctrl.getMonthlyFee = () =>
        ctrl.preferredProduct ? assetFinanceService.getMonthlyFee(ctrl.preferredProduct) : 0;

      ctrl.hasOwnershipPercentage = () => (item) => item.percent > 0;

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
